import { SideNavContext } from '@/contexts/SideNav';
import { useDisclosure } from '@chakra-ui/react';
import { ReactElement } from 'react';

interface SideNavProviderProps {
  children?: ReactElement;
}

export function SideNavProvider({ children }: SideNavProviderProps) {
  
  const { getButtonProps, isOpen: open, onToggle } = useDisclosure({ 
    defaultIsOpen: true,
  });

  const {
    getButtonProps: getButtonSubProps,
    isOpen: openSubProps
  } = useDisclosure()
  
  const context = { open, onToggle, buttonProps: getButtonProps(), getButtonSubProps, openSubProps }; 

  return (
    <SideNavContext.Provider value={context}>
      {children}
    </SideNavContext.Provider>
  );
}
